// extracted by mini-css-extract-plugin
export default {"import":"Privacy_import__XIYsU","importButton":"Privacy_importButton__39wht","alert":"Privacy_alert__xl8t+","noalert":"Privacy_noalert__LRbvF"};